"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _typeof = require("@babel/runtime/helpers/typeof");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _styledComponents = _interopRequireWildcard(require("styled-components"));

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

var MobileSkeleton = function MobileSkeleton(props) {
  return /*#__PURE__*/_react["default"].createElement("svg", props, /*#__PURE__*/_react["default"].createElement("rect", {
    rx: "4",
    fill: "#fff"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M0 4a4 4 0 0 1 4-4h312a4 4 0 0 1 4 4v166H0V4z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M32.5 212c8.56 0 15.5-6.94 15.5-15.5 0-8.56-6.94-15.5-15.5-15.5-8.56 0-15.5 6.94-15.5 15.5 0 8.56 6.94 15.5 15.5 15.5zM86.5 212c8.56 0 15.5-6.94 15.5-15.5 0-8.56-6.94-15.5-15.5-15.5-8.56 0-15.5 6.94-15.5 15.5 0 8.56 6.94 15.5 15.5 15.5z",
    stroke: "#E6E6E6"
  }), /*#__PURE__*/_react["default"].createElement("rect", {
    x: "125.5",
    y: "181.5",
    width: "56",
    height: "30",
    rx: "15",
    stroke: "#E6E6E6"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M220.5 212c8.56 0 15.5-6.94 15.5-15.5 0-8.56-6.94-15.5-15.5-15.5-8.56 0-15.5 6.94-15.5 15.5 0 8.56 6.94 15.5 15.5 15.5zM274.5 212c8.56 0 15.5-6.94 15.5-15.5 0-8.56-6.94-15.5-15.5-15.5-8.56 0-15.5 6.94-15.5 15.5 0 8.56 6.94 15.5 15.5 15.5zM16 219h36.201M71 219h36.201M204 219h36.201M259.496 219H288.5M126 219h58.553",
    stroke: "#E6E6E6"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M95.802 250.46c2.54 0 4.02-1.8 4.02-3.9 0-2.1-1.46-3.9-4.02-3.9h-5v6.74l-1.2-.02v1.08h1.2v1.66h-1.2v1.08h1.2v2.8h1.14v-2.8h4.62v-1.04l-4.62-.02v-1.68h3.86zm-3.86-6.76h3.74c1.76 0 2.94 1.18 2.94 2.86s-1.18 2.86-2.94 2.86h-3.74v-5.72z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M10.021 257.413L25.434 242M20.021 257.413L35.434 242M31.021 257.413L46.434 242M50.022 257.413L65.434 242M60.022 257.413L75.434 242M70.022 257.413L85.434 242M10 272.354h99.925M10 289.354h109.925M10 303.354h143.925",
    stroke: "#E6E6E6"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M14.548 116.507l-.232-.122-.233.122-3.007 1.579.574-3.343.045-.259-.188-.184-2.432-2.367 3.36-.488.26-.038.117-.235 1.504-3.043 1.503 3.043.116.235.26.038 3.36.488-2.43 2.367-.19.184.045.259.575 3.343-3.007-1.579zM28.409 116.507l-.233-.122-.232.122-3.007 1.579.574-3.343.045-.259-.189-.184-2.43-2.367 3.36-.488.26-.038.116-.235 1.503-3.043 1.504 3.043.116.235.26.038 3.36.488-2.43 2.367-.19.184.045.259.574 3.343-3.006-1.579zM42.27 116.507l-.233-.122-.232.122-3.007 1.579.574-3.343.045-.259-.189-.184-2.431-2.367 3.36-.488.26-.038.117-.235 1.503-3.043 1.504 3.043.116.235.26.038 3.36.488-2.43 2.367-.19.184.045.259.574 3.343-3.006-1.579zM56.13 116.507l-.232-.122-.233.122-3.006 1.579.574-3.343.045-.259-.189-.184-2.431-2.367 3.36-.488.26-.038.117-.235 1.503-3.043 1.503 3.043.117.235.26.038 3.36.488-2.431 2.367-.189.184.045.259.574 3.343-3.007-1.579zM69.991 116.507l-.232-.122-.233.122-3.006 1.579.574-3.343.044-.259-.188-.184-2.431-2.367 3.36-.488.26-.038.117-.235 1.503-3.043 1.503 3.043.117.235.26.038 3.36.488-2.431 2.367-.189.184.045.259.574 3.343-3.007-1.579zM300.044 28c.984-.409 9.956-4.316 9.956-10.873 0-6.938-5.876-6.095-5.876-6.095s-2.859.315-4.124 2.707c-1.265-2.392-4.124-2.707-4.124-2.707S290 10.19 290 17.127c0 6.557 8.972 10.464 9.956 10.873h.088zM10 142.373L20.373 132M17 142.373L27.373 132M24 142.373L34.373 132M37 142.373L47.373 132M44 142.373L54.373 132M51 142.373L61.373 132M58 142.373L68.373 132M65 142.373L75.373 132M78 142.373L88.373 132M85 142.373L95.373 132M13 157h105.35M280 155c13.255 0 24-10.745 24-24s-10.745-24-24-24-24 10.745-24 24 10.745 24 24 24zM265.081 136.457l11.619-11.618M271.567 136.457l11.619-11.618M279.351 136.457l11.619-11.618M285.838 136.457l11.618-11.618",
    stroke: "#C2C5CC"
  }));
};

MobileSkeleton.defaultProps = {
  viewBox: "0 0 320 318",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};

var DesktopSkeleton = function DesktopSkeleton(props) {
  return /*#__PURE__*/_react["default"].createElement("svg", props, /*#__PURE__*/_react["default"].createElement("rect", {
    rx: "4",
    fill: "#fff"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M256 247h232.645M256 263h172.992",
    stroke: "#E6E6E6"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M342.78 221.46c2.54 0 4.02-1.8 4.02-3.9 0-2.1-1.46-3.9-4.02-3.9h-5v6.74l-1.2-.02v1.08h1.2v1.66h-1.2v1.08h1.2v2.8h1.14v-2.8h4.62v-1.04l-4.62-.02v-1.68h3.86zm-3.86-6.76h3.74c1.76 0 2.94 1.18 2.94 2.86s-1.18 2.86-2.94 2.86h-3.74v-5.72z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M352 224h68.502M258 228.413L273.413 213M268 228.413L283.413 213M278 228.413L293.413 213M298 228.413L313.413 213M308 228.413L323.413 213M318 228.413L333.413 213M262.548 19.508l-.233-.123-.232.122-3.007 1.58.575-3.344.044-.26-.188-.183-2.432-2.367 3.361-.488.26-.038.116-.235 1.503-3.043 1.504 3.043.116.235.26.038 3.361.488-2.432 2.367-.188.184.044.259.575 3.343-3.007-1.578zM276.409 19.508l-.233-.123-.232.122-3.007 1.58.574-3.344.045-.26-.189-.183-2.431-2.367 3.361-.488.26-.038.116-.235 1.503-3.043 1.504 3.043.116.235.26.038 3.361.488-2.432 2.367-.188.184.044.259.574 3.343-3.006-1.578zM290.27 19.508l-.233-.123-.232.122-3.007 1.58.574-3.344.045-.26-.189-.183-2.431-2.367 3.361-.488.26-.038.116-.235 1.503-3.043 1.504 3.043.116.235.26.038 3.36.488-2.431 2.367-.188.184.044.259.574 3.343-3.006-1.578zM304.131 19.508l-.233-.123-.232.122-3.007 1.58.574-3.344.045-.26-.189-.183-2.431-2.367 3.36-.488.26-.038.117-.235 1.503-3.043 1.504 3.043.116.235.26.038 3.36.488-2.431 2.367-.188.184.044.259.574 3.343-3.006-1.578zM317.992 19.508l-.233-.123-.232.122-3.007 1.58.574-3.344.045-.26-.189-.183-2.431-2.367 3.36-.488.26-.038.117-.235 1.503-3.043 1.503 3.043.117.235.26.038 3.36.488-2.431 2.367-.188.184.044.259.574 3.343-3.006-1.578z",
    stroke: "#E6E6E6"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    clipRule: "evenodd",
    d: "M680.044 28c.984-.409 9.956-4.316 9.956-10.873 0-6.938-5.876-6.095-5.876-6.095s-2.859.315-4.124 2.707c-1.265-2.392-4.124-2.707-4.124-2.707S670 10.19 670 17.127c0 6.557 8.972 10.464 9.956 10.873h.088z",
    stroke: "#E6E6E6",
    strokeLinejoin: "round"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M256 49.636l15.413-15.412M266 49.636l15.413-15.412M276 49.636l15.413-15.412M286 49.636l15.413-15.412M296 49.636l15.413-15.412M316 49.636l15.413-15.412M326 49.636l15.413-15.412M336 49.636l15.413-15.412M346 49.636l15.413-15.412M356 49.636l15.413-15.412M366 49.636l15.413-15.412M376 49.636l15.413-15.412M396 49.636l15.413-15.412M406 49.636l15.413-15.412",
    stroke: "#E6E6E6"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M0 4a4 4 0 0 1 4-4h236v278H4a4 4 0 0 1-4-4V4z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    clipRule: "evenodd",
    d: "M272.5 97c8.56 0 15.5-6.94 15.5-15.5 0-8.56-6.94-15.5-15.5-15.5-8.56 0-15.5 6.94-15.5 15.5 0 8.56 6.94 15.5 15.5 15.5zM324.5 97c8.56 0 15.5-6.94 15.5-15.5 0-8.56-6.94-15.5-15.5-15.5-8.56 0-15.5 6.94-15.5 15.5 0 8.56 6.94 15.5 15.5 15.5z",
    stroke: "#E6E6E6"
  }), /*#__PURE__*/_react["default"].createElement("rect", {
    x: "361.5",
    y: "66.5",
    width: "56",
    height: "30",
    rx: "15",
    stroke: "#E6E6E6"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    clipRule: "evenodd",
    d: "M454.5 97c8.56 0 15.5-6.94 15.5-15.5 0-8.56-6.94-15.5-15.5-15.5-8.56 0-15.5 6.94-15.5 15.5 0 8.56 6.94 15.5 15.5 15.5zM504.5 97c8.56 0 15.5-6.94 15.5-15.5 0-8.56-6.94-15.5-15.5-15.5-8.56 0-15.5 6.94-15.5 15.5 0 8.56 6.94 15.5 15.5 15.5z",
    stroke: "#E6E6E6"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M256 106h36.201M307 106h36.201M490 106h31.504M431 106h48.58M362 106h55.52",
    stroke: "#E6E6E6"
  }), /*#__PURE__*/_react["default"].createElement("defs", null, /*#__PURE__*/_react["default"].createElement("pattern", {
    id: "pattern0",
    patternContentUnits: "objectBoundingBox",
    width: "1",
    height: "1"
  }, /*#__PURE__*/_react["default"].createElement("use", {
    xlinkHref: "#image0",
    transform: "matrix(.00145 0 0 .00125 -.369 0)"
  }))));
};

DesktopSkeleton.defaultProps = {
  viewBox: "0 0 700 278",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  xmlnsXlink: "http://www.w3.org/1999/xlink"
};

var HotelCardSkeleton = function HotelCardSkeleton(_ref) {
  var className = _ref.className,
      small = _ref.small;

  if (small) {
    return /*#__PURE__*/_react["default"].createElement(StyledSkeleton, {
      className: className
    }, /*#__PURE__*/_react["default"].createElement(MobileSkeleton, null));
  }

  return /*#__PURE__*/_react["default"].createElement(StyledSkeleton, {
    className: className
  }, /*#__PURE__*/_react["default"].createElement(DesktopSkeleton, null));
};

var Card = (0, _styledComponents.css)(["background-repeat:no-repeat;box-shadow:none;background-color:#fff;border:1px solid #d8d8d8;border-radius:4px;"]);

var StyledSkeleton = _styledComponents["default"].div.withConfig({
  displayName: "HotelCardSkeleton__StyledSkeleton",
  componentId: "sc-18ko452-0"
})(["", " width:100%;& svg{display:block;}"], Card);

var _default = HotelCardSkeleton;
exports["default"] = _default;